import image from "../images/menu.png";

export const Header = () => {
    return(
        <div className="header">
            <div className = "title">fashion monster</div>
            <nav>
                <ul className="menu">
                    <li>
                    <a><img src={image}/></a>
                    <ul className="menu__child">
                    <li><a href="/">ログイン</a></li>
                            <li><a href="#history">履歴</a></li>
                            <li><a href="#favorite">お気に入り</a></li>
                            <li><a href="/register-tops">トップス登録</a></li>
                            <li><a href="/register-bottoms">ボトムス登録</a></li>
                            <li><a href="/register-shoes">靴登録</a></li>
                            <li><a href="/login">ホーム</a></li>
                    </ul>
                    </li>
                </ul>
            </nav>
        </div>
    )
}